<template>
	<div>
		<breadcrumbs></breadcrumbs>
		<h1>{{title}}</h1>
	</div>
</template>

<script>
export default {
	name: "Breadcrumb",
	props: { title: String },
}
</script>

<style lang="scss">
@import "@/assets/styles/variables.scss";

.breadcrumb {
	background: transparent !important;
	background-color: transparent !important;
	padding-top: 0px !important;
	padding-bottom: 0px !important;
	padding-left: 0px !important;
	padding-right: 0px !important;

	ul {
		list-style-type: none
	}

	a {
		color: $ey-gray-alt;
		font-size: $primary-font-size;

		&.router-link-exact-active {
			color: $ey-dark-gray;
		}
	}
}

h1 {
	color: $light-gray-alt-1;
	font-size: 18px !important; 
	font-weight: bold !important;
	margin-bottom: 16px !important;
}
</style>